export const OKTA_EXTERNAL_CONFIG = {
  issuer: `${process.env.REACT_APP_EXTERNAL_ISSUER}`,
  clientId: `${process.env.REACT_APP_EXTERNAL_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_BASE_EXTERNAL_REDIRECT_URL}/login/callback`,
  scopes: ["openid", "profile", "email"],
  pkce: true,
};

export const OKTA_INTERNAL_CONFIG = {
  issuer: `${process.env.REACT_APP_INTERNAL_ISSUER}`,
  clientId: `${process.env.REACT_APP_INTERNAL_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_BASE_INTERNAL_REDIRECT_URL}/login/callback`,
  scopes: ["openid", "profile", "email"],
  pkce: true,
};

export const APPD_KEY = `${process.env.REACT_APP_APPD_KEY}`